import { EventTypes, getPageSource, track } from '@mc/track-event'
import { useBucket } from '@mc/experiments-react'

const EXPERIMENT_KEY = 'experiments_promo'
// based on checkExperimentViewedCalled of web/libs/track-event/src/core/adapters/segment/segment.ts
// to trigger the EV only once per session but it uses a different EXPERIMENT_KEY to avoid race conditions with original code
const checkCustomExperimentViewedCalled = (experimentName: string): boolean => {
  let calledExperiments: string[] = []
  const experimentCookie = window.sessionStorage.getItem(EXPERIMENT_KEY)
  if (experimentCookie) {
    calledExperiments = JSON.parse(experimentCookie)
  }
  if (!calledExperiments.includes(experimentName)) {
    // Clear previous promotion experiments and start fresh with the current one
    calledExperiments = [experimentName]
    window.sessionStorage.setItem(
      EXPERIMENT_KEY,
      JSON.stringify(calledExperiments),
    )
    return false
  }
  return true
}

// fire custom EV using the promo_key as the experimentName
// based on track and trackExperimentViewed of web/libs/track-event/src/core/adapters/segment/segment.ts
export const trackPromotionExperimentViewed = (
  promoKey: string,
  promoBucket: ReturnType<typeof useBucket>,
) => {
  if (promoKey && promoBucket) {
    const alreadyCalled =
      // eslint-disable-next-line
      process.env.NODE_ENV === 'production' &&
      checkCustomExperimentViewedCalled(promoKey)

    if (!alreadyCalled) {
      track(EventTypes.EXPERIMENT_VIEWED, {
        experimentName: promoKey,
        variationName: promoBucket,
        page_source: getPageSource(),
      })
    }
  }
}
